import { useState } from "react"
import { router, Link } from "@inertiajs/react"
import coverImage from "@/assets/capa-eneagrama.png"

interface CoverPageProps {
  onFlip: () => void
}

export function CoverPage({ onFlip }: CoverPageProps) {
  const [isFlipping, setIsFlipping] = useState(false)

  const handleFlip = () => {
    setIsFlipping(true)
    setTimeout(() => {
      onFlip()
      router.visit("/pre-test")
    }, 500)
  }

  return (
    <div className="min-h-screen flex flex-col bg-gradient-to-br from-[#f5f6f7] via-[#cfd5dc] to-[#696667]/30">
      {/* Main content */}
      <main className="flex-1 flex items-center justify-center p-4">
        <div
          className={`relative w-full max-w-2xl transition-all duration-500 ${
            isFlipping ? "animate-slide-out-left" : ""
          }`}
        >
          <div
            className="cursor-pointer hover:opacity-90 transition-opacity duration-300"
            onClick={handleFlip}
          >
            <img
              src={coverImage}
              alt="Orientação Profissional 25Segundos"
              className="w-full max-h-[calc(100vh-120px)] object-contain rounded-lg shadow-2xl"
            />
            <div className="absolute bottom-8 left-0 right-0 text-center">
              <p className="text-white text-lg font-semibold bg-black/30 backdrop-blur-sm py-3 px-6 rounded-full inline-block animate-pulse">
                ⮕ Clique para comecar
              </p>
            </div>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="py-4 px-4 border-t border-gray-300/30 bg-white/50 backdrop-blur-sm">
        <div className="max-w-6xl mx-auto relative">
          {/* Texto centralizado */}
          <p className="text-sm text-muted-foreground text-center">
            ◈ Método desenvolvido por Rafaela Ferreira e Maria Cláudia Lopes — 25Segundos ◈
          </p>
          {/* Links à direita */}
          <div className="flex items-center justify-center gap-4 text-sm mt-2 sm:mt-0 sm:absolute sm:right-0 sm:top-1/2 sm:-translate-y-1/2">
            <Link
              href="/login"
              className="text-muted-foreground hover:text-foreground transition-colors font-medium"
            >
              Entrar
            </Link>
            <Link
              href="/politica-de-privacidade"
              className="text-muted-foreground hover:text-foreground transition-colors"
            >
              Privacidade
            </Link>
            <Link
              href="/termos-de-uso"
              className="text-muted-foreground hover:text-foreground transition-colors"
            >
              Termos de Uso
            </Link>
          </div>
        </div>
      </footer>
    </div>
  )
}
